<!--==================================
=            CHARTBARAPEX            =
===================================-->

<template>
  <div justify center>
    <div id="chart-bar"></div>
  </div>
</template>
<script>
export default {
  mounted() {
    var options = {
      series: [
        {
          name: "Net Profit",
          data: [44, 55, 57, 56, 61, 58, 63, 60, 66]
        },
        {
          name: "Revenue",
          data: [76, 85, 101, 98, 87, 105, 91, 114, 94]
        },
        {
          name: "Free Cash Flow",
          data: [35, 41, 36, 26, 45, 48, 52, 53, 41]
        }
      ],
      chart: {
        type: "bar",
        height: 330,
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded"
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: false,
        width: 2,
        colors: ["transparent"]
      },
      colors: ["#d433ff", "#364cba", "#09a8fb"],
      fill: {
        type: "gradient",
        gradient: {
          type: "vertical",
          opacityFrom: 1,
          opacityTo: 1,
          gradientToColors: ["#335eff"],
          stops: [0, 100]
        }
      },
      xaxis: {
        categories: [
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct"
        ]
      },
      yaxis: {
        title: {
          text: "$ (thousands)"
        }
      },

      tooltip: {
        y: {
          formatter: function(val) {
            return "$ " + val + " thousands";
          }
        }
      }
    };
    // eslint-disable-next-line no-undef
    // eslint-disable-next-line no-redeclare
    var chart = new ApexCharts(document.querySelector("#chart-bar"), options);
    chart.render();
  }
};
</script>

<!--====  End of CHARTBARAPEX  ====-->
